import { apiClient } from '@/Clients/ApiClient';
import CheckoutService from '@/Services/CheckoutService';
import PledgeService from '@/Services/PledgeService';
import { createRequestDeduplicator } from '@/Utils/AsyncUtility';
import { paymentTypes } from '@/Models.js';

const pledgeService = new PledgeService(apiClient);
const checkoutService = new CheckoutService(apiClient);

const deduplicatePaymentMethodsRequest = createRequestDeduplicator();

// Each function takes its whole input, the currency included - nothing here reads a store.

export async function fetchCurrencies({ projectID, locationID, pricedOrderCode, appliedGiftCardIDs }) {
    const { data } = await pledgeService.getDynamicConversionCurrencies(
        projectID,
        locationID,
        pricedOrderCode,
        appliedGiftCardIDs,
    );

    return data;
}

export async function fetchAmount({ projectID, orderCode, paymentType, currency, appliedGiftCardIDs }) {
    const { data } = await pledgeService.getPaymentAmountDetails({
        orderCode,
        projectID,
        paymentType,
        dynamicCurrencyID: currency?.currencyID ?? null,
        exchangeRate: currency?.exchangeRate ?? null,
        appliedGiftCardIDs,
    });

    return data;
}

export function fetchDepositAmount(request) {
    return fetchAmount({ ...request, paymentType: paymentTypes.deposit });
}

export async function fetchMethods({ projectID, orderCode, locationIsoCode, currencyShortName, reason, appliedGiftCardIDs }) {
    const params = {
        currencyShortName,
        projectID,
        locationIsoCode,
        orderCode,
        reason,
        appliedGiftCardIDs,
    };

    const { data } = await deduplicatePaymentMethodsRequest(
        JSON.stringify(params),
        () => pledgeService.getAvailablePaymentMethods(params),
    );

    return data;
}

export async function fetchInstallments({ projectID, installmentsOrderCode, exchangeRate, appliedGiftCardIDs }) {
    const { data } = installmentsOrderCode
        ? await checkoutService.calculateOrderInstallmentPlan(projectID, exchangeRate, installmentsOrderCode, appliedGiftCardIDs)
        : await checkoutService.calculateCartInstallmentPlan(projectID, exchangeRate, appliedGiftCardIDs);

    return data;
}

export async function fetchPaymentTypes({ projectID, pricedOrderCode, checkoutMode, appliedGiftCardIDs }) {
    const { data } = await pledgeService.getAvailablePaymentTypes(
        projectID,
        pricedOrderCode,
        checkoutMode,
        appliedGiftCardIDs,
    );

    return data;
}
